<script setup lang="ts">
const Props = defineProps({
  helpModalItems: {
    type: Object,
    required: true,
  },
});

const helpModalFlg = ref(false);

const { $backfaceFixed } = useNuxtApp();

const openHelpModal = () => {
  helpModalFlg.value = true;
  $backfaceFixed(true);
};

const closeHelpModal = () => {
  helpModalFlg.value = false;
  $backfaceFixed(false);
};
</script>
<template>
  <div>
    <OrganismsCompareHelpModalBtn @open-help-modal="openHelpModal" />
    <OrganismsCompareHelpModalContents
      :help-modal-flg="helpModalFlg"
      :help-modal-ttl="helpModalItems.ttl"
      :help-modal-txt="helpModalItems.txt"
      @close-help-modal="closeHelpModal"
    />
  </div>
</template>

<style lang="scss" scoped>
.helpModal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.helpModal-content {
  width: 91%;
  overflow: hidden;
  background-color: $colorDefaultBackground;
}

.helpModal-header {
  display: flex;
  align-items: flex-start;
  background: $colorGray;
  padding: 3.7% 6.4% 4.5%;
  font-weight: bold;
  font-size: px(18);
}

.helpModal-close {
  width: 5.3%;
  padding: 2.5% 0 0 3.2%;
}

.helpModal-text {
  padding: 4.2% 6.4% 6.4%;
}

// transition
.helpModal-enter-active,
.helpModal-leave-active {
  transition: opacity 0.4s;
}
.helpModal-leave-active {
  transition: opacity 0.6s ease 0.1s;
}
.helpModal-enter,
.helpModal-leave-to {
  opacity: 0;
}
@include media(pc) {
  .helpModal-content {
    width: 560px;
  }

  .helpModal-header {
    font-size: px(22);
    padding: 14px 24px 17px;
  }

  .helpModal-close {
    width: 18px;
    padding: 7px 0 0 20px;
    margin-left: auto;
  }

  .helpModal-text {
    padding: 16px 24px 24px;
  }
}
</style>
